import { Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAppSelector } from "@Src/app/hooks";

interface Props {
  component: React.ComponentType
  path?: string
}


export const PrivateRoute: React.FC<Props> = ({ component: RouteComponent }) => {
  const isLoggedIn = useAppSelector((state) => state?.login?.isLoggedIn);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      // navigate("/", { replace: true });
      window.location.replace(`${process.env.REACT_APP_MAIN_SITE_URL}?logout=true`);
    }
  }, [isLoggedIn]);

  if (isLoggedIn) {
    return <RouteComponent />
  }
  return <></>
}

export const UnAuthorisedRoute: React.FC<Props> = ({ component: RouteComponent }) => {
  const isLoggedIn = useAppSelector((state) => state?.login?.isLoggedIn);
  if (isLoggedIn) {
  } else {
    return <RouteComponent />
  }
  return <Navigate to="/" />
}

// export const UnAuthorisedRoute: React.FC<Props> = ({ component: RouteComponent }) => {


//   const dispatch = useAppDispatch();
//   const token = useAppSelector((state) => state?.login?.loginToken);
//   const refreshToken = useAppSelector((state) => state?.login?.loginRefreshToken);
//   const userId = useAppSelector((state) => state?.login?.userID);
//   const userFirstName = useAppSelector((state) => state?.login?.Firstname);
//   const userLastName = useAppSelector((state) => state?.login?.Lastname);
//   const userEmail = useAppSelector((state) => state?.login?.Email);
//   const payload = {
//     token: token,
//     refreshToken: refreshToken,
//     userId: userId,
//     userFirstName: userFirstName,
//     userLastName: userLastName,
//     userEmail: userEmail
//   };
//   // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", payload);
//   const encoded = btoa(JSON.stringify(payload));
//   dispatch(showSpinner(false));

//   useEffect(() => {
//     if (isLoggedIn()) {
//       window.location.replace(`${LOGIN_SUCCESS_EXTERNAL_URL}?data=${encodeURIComponent(encoded)}`);
//     }
//   }, [isLoggedIn]);


//   if (!isLoggedIn()) {

//     return <RouteComponent />
//   }
//   return <Navigate to='/'/>
// }
